import { render, staticRenderFns } from "./goodsChange.vue?vue&type=template&id=59b03c99&scoped=true"
import script from "./goodsChange.vue?vue&type=script&lang=js"
export * from "./goodsChange.vue?vue&type=script&lang=js"
import style0 from "./goodsChange.vue?vue&type=style&index=0&id=59b03c99&prod&scoped=true&lang=css"
import style1 from "./goodsChange.vue?vue&type=style&index=1&id=59b03c99&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b03c99",
  null
  
)

export default component.exports